/* eslint-disable */
import moment from 'moment';
import { ListTable } from '@/Components/ListTable';
import { useOpenChildQrActivitiesModal } from '@/Components/Modals/ChildQrActivitiesModal';
import styles from './ScanWiseTable.module.scss';

// BE row shape (fmcg_packaging_helpers.getFmcgPackTrail):
//   { id, qrCode, packageId, storeId, childVariantId, packageVariantId,
//     packagingMappingId, movementType, activityDate, qty, postUpdateQty,
//     stockUpdated, reason, refId, refType, shortInfo, activityBy }

const TABLE_COLUMNS = [
	{ title: 'Pack QR', config: { type: 'DATA' } },
	{ title: 'Movement', config: { type: 'DATA' } },
	{ title: 'Child Qty', config: { type: 'DATA' } },
	{ title: 'Post Updated Packs', config: { type: 'DATA' } },
	{ title: 'Reason', config: { type: 'DATA' } },
	{ title: 'Reference', config: { type: 'DATA' } },
	{ title: 'Note', config: { type: 'DATA' } },
	{ title: 'Activity Date', config: { type: 'DATA' } },
	{ title: 'Activity By', config: { type: 'DATA' } },
];

const COLMAP = {
	'Pack QR': 'qrCode',
	Movement: 'movementType',
	'Child Qty': 'qty',
	'Post Updated Packs': 'postUpdateQty',
	Reason: 'reason',
	Reference: 'refType',
	Note: 'shortInfo',
	'Activity Date': 'activityDate',
	'Activity By': 'activityBy',
};

const PackScanWiseTable = (props) => {
	const { data } = props;
	const openChildQrActivities = useOpenChildQrActivitiesModal();

	const SPECIAL_ITEMS = {
		'Pack QR': (qrCode, row) => (
			<button
				type='button'
				className='underline text-blue-400 hover:text-blue-600 bg-transparent border-0 p-0 cursor-pointer'
				onClick={() => openChildQrActivities(row?.packageId, qrCode)}
				title='Show child QR activities'
			>
				{qrCode}
			</button>
		),
		Movement: (movementType) => {
			const colorClass = movementType === 'Stocked In'
				? 'bg-green-100 text-green-800'
				: 'bg-red-100 text-red-800';
			return (
				<span className={`px-2 py-1 rounded text-xs font-medium ${colorClass}`}>
					{movementType}
				</span>
			);
		},
		'Child Qty': (qty) => (
			<div className='text-right'>{qty ?? '—'}</div>
		),
		'Post Updated Packs': (postUpdateQty) => (
			<div className='text-right'>{postUpdateQty ?? '—'}</div>
		),
		Reason: (reason) => (
			<div className='text-left'>{reason || '—'}</div>
		),
		Reference: (refType, row) => {
			if (!refType && !row?.refId) return '—';
			return (
				<div className='text-left text-xs text-gray-700'>
					{refType}{row?.refId != null ? ` #${row.refId}` : ''}
				</div>
			);
		},
		Note: (shortInfo) => (
			<div className='text-left text-xs text-gray-600'>{shortInfo || '—'}</div>
		),
		'Activity Date': (activityDate) => (
			<div className='w-[150px]'>
				{activityDate ? moment(activityDate).format('YYYY-MM-DD HH:mm') : '—'}
			</div>
		),
		'Activity By': (activityBy) => (
			<div className='text-left'>{activityBy || '—'}</div>
		),
	};

	const getRowStyles = (ele) => {
		if (ele?.movementType === 'Stocked In') return 'bg-[#00ff0d41]';
		if (ele?.movementType === 'Stocked Out') return 'bg-[#ff0c0c41]';
		return '';
	};

	return (
		<div className={`${styles.root} ${styles.small}`}>
			<ListTable
				allowCheckList={false}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={(data || []).map((ele) => ({
					...ele,
					rowStyles: getRowStyles(ele),
				}))}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};

export default PackScanWiseTable;
